.wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    width: 100%;
}

.label {
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
    line-height: var(--tempest-leading-snug);
}

.field {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--tempest-space-1);
    padding: 4px var(--tempest-space-2);
    min-height: var(--tempest-control-height-md);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-control-radius);
    background-color: var(--tempest-bg);
    box-shadow: var(--tempest-shadow-xs);
    cursor: text;
    transition: var(--tempest-transition-color), var(--tempest-transition-shadow);
}

.field:focus-within {
    border-color: var(--tempest-primary);
    box-shadow: 0 0 0 var(--tempest-focus-ring-width) var(--tempest-focus-ring-color);
}

.wrapper.error .field {
    border-color: var(--tempest-danger);
}

.wrapper.error .field:focus-within {
    box-shadow: 0 0 0 var(--tempest-focus-ring-width)
        color-mix(in srgb, var(--tempest-danger) 25%, transparent);
}

.chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background-color: var(--tempest-surface-2);
    color: var(--tempest-text);
    padding: 2px 4px 2px 8px;
    border-radius: var(--tempest-radius-full);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-xs);
    font-weight: var(--tempest-weight-semibold);
}

.remove {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .remove:hover {
        background-color: rgba(0, 0, 0, 0.1);
    }
}

.input {
    border: none;
    outline: none;
    background: transparent;
    flex: 1;
    min-width: 80px;
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-control-font-md);
    color: var(--tempest-text);
}

.helper {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
}

.errorText {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-danger);
    line-height: var(--tempest-leading-snug);
}
